/* Nocéa — JS natif, sans dépendance */
(function () {
  'use strict';
  var N = window.Nocea || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = N.moneyFormat || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    var thousands = function (x, sep) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var parts = comma.split(',');
    var withSpace = thousands(parts[0], ' ') + ',' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount') return thousands(v.split('.')[0], ',') + '.' + v.split('.')[1];
      if (k === 'amount_no_decimals') return thousands(String(Math.round(cents / 100)), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return thousands(String(Math.round(cents / 100)), '.');
      if (k === 'amount_with_comma_separator') return withSpace;
      return withSpace;
    });
  }

  /* ---------- Apparition au défilement ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -40px' });
    var watchReveal = function (root) { $$('.reveal:not(.is-in)', root).forEach(function (el) { io.observe(el); }); };
    watchReveal(document);
    N.watchReveal = watchReveal;
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    N.watchReveal = function (root) { $$('.reveal', root).forEach(function (el) { el.classList.add('is-in'); }); };
  }

  /* ---------- Bandeau d'annonces (rotation mobile) ---------- */
  $$('[data-rotate]').forEach(function (row) {
    var msgs = $$('.ann__msg', row); if (!msgs.length) return;
    var i = 0; msgs[0].classList.add('is-on');
    if (msgs.length > 1) setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4000);
  });

  /* ---------- Menu mobile ---------- */
  var menu = $('[data-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu && menu.classList.remove('is-open'); document.body.style.overflow = ''; }); });

  /* ---------- Panier tiroir ---------- */
  var drawer = function () { return $('#CartDrawer'); };
  function openCart() { var d = drawer(); if (!d) { window.location = N.routes.cart_url; return; } d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; bindDrawer(); }
  function closeCart() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function renderCart(html, count) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $('#CartDrawer', tmp); var d = drawer();
    if (fresh && d) { var wasOpen = d.classList.contains('is-open'); d.innerHTML = fresh.innerHTML; if (wasOpen) d.classList.add('is-open'); bindDrawer(); }
    if (typeof count === 'number') $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = count === 0; });
  }
  function refreshCart() {
    return fetch(N.routes.root + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      return fetch(N.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(html, c.item_count); });
    });
  }
  function bindDrawer() {
    var d = drawer(); if (!d) return;
    $$('[data-drawer-close]', d).forEach(function (b) { b.onclick = closeCart; });
    $$('[data-line-change]', d).forEach(function (b) {
      b.onclick = function () {
        b.disabled = true;
        fetch(N.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.getAttribute('data-line-change'), quantity: +b.getAttribute('data-qty') }) })
          .then(function () { return refreshCart(); });
      };
    });
  }
  bindDrawer();
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); menu && menu.classList.remove('is-open'); document.body.style.overflow = ''; } });

  function addToCart(items, btn, errEl) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return fetch(N.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(function () { openCart(); })
      .catch(function (err) { if (errEl) { errEl.hidden = false; errEl.textContent = (err && (err.description || err.message)) || 'Impossible d\'ajouter ce produit.'; } else { alertless(err); } })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
  function alertless(err) { console.warn('Ajout au panier impossible', err); }

  /* Formulaires d'ajout (cartes + fiche produit) */
  $$('form[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[data-qty-input]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var offer = form.querySelector('[data-offer].is-on');
      var items = [{ id: +id, quantity: qty }];
      if (offer) {
        var ov = offer.getAttribute('data-variant');
        if (ov) items = [{ id: +ov, quantity: qty }];
        else items = [{ id: +id, quantity: qty * (+offer.getAttribute('data-qty') || 1) }];
      }
      addToCart(items, form.querySelector('[type="submit"]'), form.querySelector('[data-atc-error]'));
    });
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var form = $('#ProductForm', sec); if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var variantsEl = $('[data-variants]', sec);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    var current = variants ? variants.filter(function (v) { return String(v.id) === idInput.value; })[0] : null;
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), saveEl = $('[data-save]', sec), thirdEl = $('[data-third]', sec);
    var atc = $('[data-atc]', sec), atcLabel = $('[data-atc-label]', sec);
    var baseLabel = atcLabel ? atcLabel.textContent.split('·')[0].trim() : 'Ajouter au panier';
    var qtyInput = $('[data-qty-input]', sec);
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function offerTotals() {
      var o = $('[data-offer].is-on', sec);
      var price = current ? current.price : null;
      if (!price) { var p = priceEl && priceEl.getAttribute('data-cents'); price = p ? +p : 0; }
      if (o && !o.getAttribute('data-variant')) {
        var q = +o.getAttribute('data-qty') || 1, d = +o.getAttribute('data-discount') || 0;
        return Math.round(price * q * (100 - d) / 100);
      }
      if (o && o.getAttribute('data-variant')) {
        var t = $('[data-offer-price]', o); return t ? t.textContent : null;
      }
      return price;
    }
    function updateLabel() {
      if (!atcLabel) return;
      if (current && !current.available) { atcLabel.textContent = 'Épuisé'; atc.disabled = true; return; }
      atc && (atc.disabled = false);
      var q = qtyInput ? Math.max(1, +qtyInput.value || 1) : 1;
      var tot = offerTotals();
      var txt = typeof tot === 'number' ? money(tot * q) : tot;
      atcLabel.textContent = baseLabel + (txt ? ' · ' + txt : '');
      if (stickyPrice && txt) stickyPrice.textContent = txt;
    }
    function updateOffers() {
      if (!current) return;
      $$('[data-offer]', sec).forEach(function (o) {
        if (o.getAttribute('data-variant')) return;
        var q = +o.getAttribute('data-qty') || 1, d = +o.getAttribute('data-discount') || 0;
        var pr = $('[data-offer-price]', o), cp = $('[data-offer-compare]', o);
        if (pr) pr.textContent = money(Math.round(current.price * q * (100 - d) / 100));
        if (cp) cp.textContent = money((current.compare_at_price > current.price ? current.compare_at_price : current.price) * q);
      });
    }
    function setVariant(v) {
      current = v; if (!v) { atc && (atc.disabled = true); atcLabel && (atcLabel.textContent = 'Indisponible'); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var has = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { cmpEl.hidden = !has; if (has) cmpEl.textContent = money(v.compare_at_price); }
      if (saveEl) { saveEl.hidden = !has; if (has) saveEl.textContent = '-' + money(v.compare_at_price - v.price); }
      if (thirdEl) thirdEl.textContent = money(Math.round(v.price / 3));
      if (v.featured_media) { var m = sec.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (m && m.parentNode.firstElementChild !== m) { m.parentNode.scrollTo ? m.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' }) : 0; } }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      updateOffers(); updateLabel(); markUnavailable();
    }
    function selected() { return $$('.vp__opt', sec).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function markUnavailable() {
      if (!variants) return;
      var sel = selected();
      $$('.vp__opt', sec).forEach(function (fs, idx) {
        $$('label', fs).forEach(function (lab) {
          var val = $('input', lab).value;
          var test = sel.slice(); test[idx] = val;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
          lab.classList.toggle('is-off', !ok);
        });
        var out = $('[data-option-value]', fs); if (out) out.textContent = sel[idx];
      });
    }
    $$('.vp input', sec).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = selected();
        var v = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
        setVariant(v || null);
      });
    });
    markUnavailable();

    $$('[data-offer]', sec).forEach(function (o) {
      o.addEventListener('click', function () { $$('[data-offer]', sec).forEach(function (x) { x.classList.remove('is-on'); }); o.classList.add('is-on'); var r = $('input', o); if (r) r.checked = true; updateLabel(); });
    });
    var minus = $('[data-qty-minus]', sec), plus = $('[data-qty-plus]', sec);
    minus && minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (+qtyInput.value || 1) - 1); updateLabel(); });
    plus && plus.addEventListener('click', function () { qtyInput.value = (+qtyInput.value || 1) + 1; updateLabel(); });
    qtyInput && qtyInput.addEventListener('change', updateLabel);
    updateOffers(); updateLabel();

    /* Galerie mobile : compteur + vignettes */
    var gal = $('[data-gallery]', sec), count = $('[data-gal-count]', sec), thumbs = $$('[data-thumb]', sec);
    if (gal) {
      var total = gal.children.length;
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        if (count) count.textContent = (i + 1) + ' / ' + total;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-thumb'); gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' }); }); });
    }

    /* Barre d'achat collante */
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var below = e.boundingClientRect.top < 0; sticky.classList.toggle('is-on', !e.isIntersecting && below); sticky.setAttribute('aria-hidden', String(!(!e.isIntersecting && below))); }); }).observe(atc);
      var sb = $('[data-sticky-btn]', sticky); sb && sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });

  /* ---------- Date de livraison estimée + compte à rebours ---------- */
  (function () {
    var els = $$('[data-delivery]'); if (!els.length || !N.delivery) return;
    var days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'], months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    function addBusiness(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    function tick() {
      var now = new Date(), cut = new Date(now); cut.setHours(N.delivery.cutoff, 0, 0, 0);
      var start = now;
      var weekend = now.getDay() === 0 || now.getDay() === 6;
      if (now > cut || weekend) { start = addBusiness(now, 1); }
      var a = addBusiness(start, N.delivery.min), b = addBusiness(start, N.delivery.max);
      var txt;
      if (now < cut && !weekend) {
        var ms = cut - now, h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
        txt = 'Commandez dans <b class="accent">' + h + ' h ' + (m < 10 ? '0' : '') + m + ' min</b> : livré entre le <b>' + fmt(a) + '</b> et le <b>' + fmt(b) + '</b>';
      } else {
        txt = 'Livré entre le <b>' + fmt(a) + '</b> et le <b>' + fmt(b) + '</b>';
      }
      els.forEach(function (el) { el.innerHTML = txt; });
    }
    tick(); setInterval(tick, 30000);
  })();

  /* Compte à rebours d'offre (date de fin réelle) */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown').replace(' ', 'T'));
    if (isNaN(end)) { el.hidden = true; return; }
    function t() {
      var ms = end - new Date(); if (ms <= 0) { el.innerHTML = 'Offre terminée'; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      el.querySelector('[data-d]').textContent = p(d); el.querySelector('[data-h]').textContent = p(h); el.querySelector('[data-m]').textContent = p(m); el.querySelector('[data-s]').textContent = p(s);
    }
    t(); setInterval(t, 1000);
  });

  /* ---------- Vidéos UGC ---------- */
  $$('[data-ugc-play]').forEach(function (b) {
    b.addEventListener('click', function () {
      var item = b.closest('.ugc__item'), v = item.querySelector('video');
      if (!v) return;
      if (v.paused) { $$('.ugc__item video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.ugc__item').classList.remove('is-playing'); } }); v.muted = false; v.play(); item.classList.add('is-playing'); }
      else { v.pause(); item.classList.remove('is-playing'); }
    });
  });
  $$('.ugc__item video').forEach(function (v) { v.addEventListener('click', function () { v.pause(); v.closest('.ugc__item').classList.remove('is-playing'); }); });

  /* ---------- Collection : filtres, tri, afficher plus ---------- */
  var filterForm = $('[data-filter-form]');
  function applyFilters(params) {
    var url = window.location.pathname + '?' + params.toString();
    window.location.href = url;
  }
  if (filterForm) {
    filterForm.addEventListener('change', function () { applyFilters(new URLSearchParams(new FormData(filterForm))); });
  }
  var sort = $('[data-sort]');
  sort && sort.addEventListener('change', function () { var p = new URLSearchParams(window.location.search); p.set('sort_by', sort.value); p.delete('page'); applyFilters(p); });
  var side = $('[data-filters]');
  $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { side && side.classList.add('is-open'); }); });
  $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { side && side.classList.remove('is-open'); }); });
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]'); if (!more) return;
    e.preventDefault(); more.textContent = 'Chargement…';
    fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-grid]'), next = $('[data-grid]', doc);
      $$('.card', next).forEach(function (c) { grid.appendChild(c); });
      N.watchReveal && N.watchReveal(grid);
      var oldMore = more.closest('.more'), newMore = $('.more', doc);
      if (newMore) oldMore.replaceWith(newMore); else oldMore.remove();
      $$('form[data-atc-form]', grid).forEach(function (f) { if (!f._b) { f._b = 1; f.addEventListener('submit', function (ev) { ev.preventDefault(); addToCart([{ id: +f.querySelector('[name="id"]').value, quantity: 1 }], f.querySelector('[type="submit"]')); }); } });
    });
  });

  /* ---------- Recommandations produit ---------- */
  $$('[data-recos]').forEach(function (s) {
    var grid = $('.grid', s); if (!grid || grid.children.length) return;
    fetch(s.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), g = $('[data-recos] .grid', doc);
      if (g && g.children.length) { grid.innerHTML = g.innerHTML; N.watchReveal && N.watchReveal(grid); }
      else s.hidden = true;
    }).catch(function () { s.hidden = true; });
  });

  /* ---------- Quiz ---------- */
  $$('[data-quiz]').forEach(function (q) {
    var steps = $$('[data-qz-step]', q), res = $('[data-qz-result]', q), bar = $('[data-qz-bar]', q), answers = [];
    function show(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      res.classList.toggle('is-on', i >= steps.length);
      bar.style.width = Math.min(100, (i / steps.length) * 100) + '%';
      if (i >= steps.length) { $$('[data-qz-res]', res).forEach(function (r) { r.hidden = +r.getAttribute('data-qz-res') !== answers[0]; }); }
    }
    $$('[data-qz-answer]', q).forEach(function (b) { b.addEventListener('click', function () { var st = +b.closest('[data-qz-step]').getAttribute('data-qz-step'); answers[st] = +b.getAttribute('data-qz-answer'); show(st + 1); }); });
    var rs = $('[data-qz-restart]', q); rs && rs.addEventListener('click', function () { answers = []; show(0); });
  });
})();
